import React from "react";

const OrderContainer1 = ({ data }) => {
  console.log(data);
  return (
    <div className="w-full mt-6 p-6 bg-gray-200 rounded text-xs">
      <p className="text-sm font-semibold ">Order ID : {data?._id}</p>
      <div className="my-3 grid lg:grid-cols-2 md:grid-cols-1 sm:grid-cols-1 lg:gap-x-20 md:gap-x-10 sm:gap-x-6">
        <p className="text-sm uppercase">
          Order Status: <span className="font-semibold">{data?.status}</span>{" "}
        </p>
        <p className="text-sm uppercase">
          Payment Status:
          <span className="font-semibold"> {data?.payment_status}</span>
        </p>
        <p>Receiver Name: {data?.buyer_name}</p>
        <p>Receiver Address: {data?.address}</p>
        <p>
          Receiver Phone:
          <span className="font-semibold text-sm"> {data?.phone}</span>{" "}
        </p>
        <p>
          Purchase Amount:
          <span className="font-semibold text-sm">BDT {data?.amount}</span>
        </p>
        <p>Payment Method : {data?.payment_method}</p>
      </div>

      <p className="text-sm font-semibold">Order Details</p>
      {data?.products?.map((x, index) => {
        return (
          <div className="flex py-3 px-6 justify-between gap-3 items-start border border-gray-200  my-3 bg-white rounded">
            {/* details & quantity incre  */}
            <div className="flex ">
              <img className="w-16 rounded-lg" src={x?.productId?.img} alt="" />
              <div className="ml-4">
                <p className="font-semibold mb-2 uppercase">Product Details</p>
                <p>Name: {x?.productId?.title}</p>
                <p className="">Unit Price: BDT {x?.purchase_price}</p>
              </div>
            </div>
            <div className="text-xs">
              <p className="font-semibold mb-2 uppercase">Cost Details</p>
              <p className="">
                Total Price: BDT {x?.purchase_price * x?.quantity}
              </p>
              <p>Quantity: {x?.quantity}</p>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default OrderContainer1;
